<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">{{category}}</span>
                    </div>
                </ion-buttons>

            </ion-toolbar>
            <br/>

            <!-- edit da qui... -->
            <ion-searchbar  (ionInput)="searchCat()" [(ngModel)]="searchWord"></ion-searchbar>

            <h3 class="panel-title">F.A.Q</h3>
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content overflow-auto">

            <div class="wrapper">
                <div class="content">
                    <!-- edit da qui... -->
                    <ion-accordion-group *ngFor="let faq of faqs" class="" value="okaa">
                        <ion-accordion value="{{faq.id}}" class="box glass-blurred-background">
                            <ion-text slot="header">
                                <p class="question" [innerHTML]="faq.question|highlight:searchWord"></p>
                            </ion-text>
                            <ion-text slot="content">
                                <p class="answer" [innerHTML]="faq.answer|highlight:searchWord">   </p>
                            </ion-text>

                        </ion-accordion>
                    </ion-accordion-group>

                    <!-- ...a qui -->
                </div>
            </div>
        </ion-content>
    </div>
</div>
